/* src/app/modules/spare-parts/service-tickets-table-desktop/service-tickets-table-desktop.component.scss */
:host {
  display: block;
  overflow-x: auto;
}
#sp-header-created {
  padding-left: 3.75rem;
}
.status-color {
  border-left-width: 0.25rem;
  border-left-style: solid;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.status-color--green {
  border-left-color: #009a38;
}
.status-color--yellow {
  border-left-color: #ffd201;
}
.status-color--red {
  border-left-color: #e7001d;
}
.status-color--gray {
  border-left-color: #808080;
}
.ellipsis {
  text-wrap: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
.ticket-number {
  display: flex;
  flex-flow: row nowrap;
  gap: 0.4rem;
  align-items: center;
}
.ticket-number sh-icon {
  visibility: hidden;
  cursor: pointer;
}
.ticket-number:hover {
  text-decoration: underline;
}
.ticket-number:hover sh-icon {
  visibility: visible;
}
.cell-inner-table {
  padding-left: unset;
}
.no-expand-icon {
  padding-left: var(--sh-table-cell-first-nested-padding);
}
.tagged-creation-date {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.tagged-creation-date span.tag-close {
  line-height: var(--sh-text-body1-line-height);
}
sh-table {
  min-width: fit-content;
  width: 100%;
}
/*# sourceMappingURL=service-tickets-table-desktop.component.css.map */
